import { render, staticRenderFns } from "./RangeBgVideo.vue?vue&type=template&id=0cb2debe&scoped=true&"
import script from "./RangeBgVideo.vue?vue&type=script&lang=js&"
export * from "./RangeBgVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2debe",
  null
  
)

export default component.exports